import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/matzeva.constants';
import { getAll, getForm, getOne, save, softDelete } from 'services/matzeva.services';

export function* matzevaDelete(action: AnyAction): Generator {
  try {
    const { id } = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.MATZEVA_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.MATZEVA_ON_DELETE_FAILED, error });
  }
}

export function* matzevaGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({
      type: constants.MATZEVA_ON_GET_ALL_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.MATZEVA_ON_GET_ALL_FAILED, error });
  }
}

export function* matzevaGetForm(): Generator {
  try {
    const { data }: any = yield call(getForm);
    yield put({ type: constants.MATZEVA_ON_GET_FORM_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.MATZEVA_ON_GET_FORM_FAILED, error });
  }
}

export function* matzevaGetOne(action: AnyAction): Generator {
  try {
    const { id } = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.MATZEVA_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.MATZEVA_ON_GET_ONE_FAILED, error });
  }
}

export function* matzevaSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.MATZEVA_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.MATZEVA_ON_SAVE_FAILED, error });
  }
}

export function* watchMatzeva(): Generator {
  yield all([
    takeLatest(constants.MATZEVA_ON_DELETE_REQUESTED, matzevaDelete),
    takeLatest(constants.MATZEVA_ON_GET_ALL_REQUESTED, matzevaGetAll),
    takeLatest(constants.MATZEVA_ON_GET_FORM_REQUESTED, matzevaGetForm),
    takeLatest(constants.MATZEVA_ON_GET_ONE_REQUESTED, matzevaGetOne),
    takeLatest(constants.MATZEVA_ON_SAVE_REQUESTED, matzevaSave),
  ]);
}
